import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify';
import VueGtag from "vue-gtag";
import gaaVueLib from 'gaa-vue-lib';


if(process.env.VUE_APP_GA_MEASUREMENT_ID && process.env.VUE_APP_GA_MEASUREMENT_ID.startsWith('G-')){
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GA_MEASUREMENT_ID }
  }, router);
}

Vue.use(gaaVueLib, { store });

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV==='production' ? false:true;
Vue.config.debug = process.env.NODE_ENV==='production' ? false:true;
Vue.config.silent = process.env.NODE_ENV==='production' ? false:true;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')